/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Detail_Rail_Alternative_ToInputs */

const en_directory_detail_rail_alternative_to = /** @type {(inputs: Directory_Detail_Rail_Alternative_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alternative to`)
};

const zh_directory_detail_rail_alternative_to = /** @type {(inputs: Directory_Detail_Rail_Alternative_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`可替代`)
};

/**
* | output |
* | --- |
* | "Alternative to" |
*
* @param {Directory_Detail_Rail_Alternative_ToInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_detail_rail_alternative_to = /** @type {((inputs?: Directory_Detail_Rail_Alternative_ToInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Detail_Rail_Alternative_ToInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_detail_rail_alternative_to(inputs)
	return zh_directory_detail_rail_alternative_to(inputs)
});
export { directory_detail_rail_alternative_to as "directory.detail.rail.alternative_to" }